import {AppApiService} from "./app-api.service";
import type {AppMetadataDto} from "../models/interfaces/app-metadata-dto.interface";
import type {UpdateThemingDto} from "../models/interfaces/update-theming-dto.interface";
import type {ThemingResponseDto} from "../models/interfaces/theming-response-dto.interface";
import type {FileDto} from "../models/interfaces/file-dto.interface";
import {UpdateRequiredDuringVisitBody} from "../models/interfaces/update-required-during-visit-body.interface";
import {UpdateOptionalDuringVisitBody} from "../models/interfaces/update-optional-during-visit-body.interface";
import {DuringVisitInfo} from "../models/interfaces/during-visit-info.interface";

class AppMetadataApiService extends AppApiService {
    public async getAppMetadata(): Promise<AppMetadataDto> {
        return await this.get<AppMetadataDto>(`/app/metadata`, {
            errorMessage: "Błąd podczas pobierania informacji o aplikacji."
        })
            .catch((error) => {
                throw error;
            });
    }

    public async updateTheming(data: UpdateThemingDto): Promise<ThemingResponseDto> {
        return await this.put<ThemingResponseDto>(`/app/theming`, data, {
            errorMessage: "Błąd podczas aktualizacji motywu.",
            successMessage: "Motyw został zaktualizowany pomyślnie"
        })
            .catch((error) => {
                throw error;
            });
    }

    public async toggleVisibility(): Promise<void> {
        return await this.post<void>(`/app/visibility/toggle`, {}, {
            errorMessage: "Błąd podczas zmiany widoczności aplikacji.",
            successMessage: "Widoczność aplikacji została zaktualizowana"
        })
            .catch((error) => {
                throw error;
            });
    }

    public async getWidgetImage(): Promise<FileDto> {
        return await this.get<FileDto>(`/app/widget-image`, {
            errorMessage: "Błąd podczas pobierania zdjęcia widgetu."
        })
            .catch((error) => {
                throw error;
            });
    }

    public async uploadWidgetImage(file: File): Promise<void> {
        const formData = new FormData();
        formData.append('image', file);

        return await this.post<void>(`/app/widget-image`, formData, {
            errorMessage: "Błąd podczas przesyłania zdjęcia widgetu.",
            successMessage: "Zdjęcie widgetu zostało zaktualizowane pomyślnie"
        })
            .catch((error) => {
                throw error;
            });
    }

    public async updateRequiredDuringVisit(body: UpdateRequiredDuringVisitBody): Promise<void> {
        return await this.put<void>(`/app/during-visit/required`, body, {
            errorMessage: "Nie udało się zapisać zmian w sekcji „Wymagane”.",
        })
            .catch((error) => {
                throw error;
            });
    }

    public async updateOptionalDuringVisit(body: UpdateOptionalDuringVisitBody): Promise<void> {
        return await this.put<void>(`/app/during-visit/optional`, body, {
            errorMessage: "Nie udało się zapisać zmian w sekcji „Opcjonalne”.",
        })
            .catch((error) => {
                throw error;
            });
    }

    public async getDuringVisitInfo() {
        return await this.get<DuringVisitInfo>(`/app/during-visit`, {
            errorMessage: "Nie udało się pobrać informacji o przygotowaniu do wizyty.",
        })
            .catch((error) => {
                throw error;
            });
    }
}

export default new AppMetadataApiService();

